import {AuthPanel, NotFound, PrivateRoute, UserRole} from 'marine-panel-common-web';
import {Route} from 'react-router';
import App from '../App';
import PanelHost from '../components/PanelHost';
import {loginFormConfig} from './authFormConfig/loginFormConfig';
import {resetPasswordFormConfig} from './authFormConfig/resetPasswordFormConfig';
import {newPasswordFormConfig} from './authFormConfig/newPasswordFormConfig';

const routes = [
    <Route path="/" element={<App />} key="home" />,
    <Route
        path="/panel/*"
        key="panel"
        element={
            <PrivateRoute userRole={UserRole.ADMIN}>
                <PanelHost envData={process.env} />
            </PrivateRoute>
        }
    />,
    <Route
        path="/auth/*"
        element={
            <AuthPanel
                formConfig={{
                    login: loginFormConfig,
                    resetPassword: resetPasswordFormConfig,
                    newPassword: newPasswordFormConfig,
                }}
                envData={process.env}
                userRole={UserRole.ADMIN}
            />
        }
        key="auth"
    />,
    <Route path="*" key="not-found" element={<NotFound />} />,
];
export default routes;
